export enum Events {
    reload = 'eventgallery-minicart-reload',
    prepareAdd2cartDialogContent = 'eventgallery-prepare-add2cartdialogcontent',
    rebindAdd2CartButtons = 'eventgallery-rebind-add2cart-buttons'
}